
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/gcs",
      function () {
        return require("private-next-pages/destinations/gcs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/gcs"])
      });
    }
  